export enum AvatarSizes {
  XxSmall = 'xxSmall',
  XSmall = 'xSmall',
  Small = 'small',
  Normal = 'normal',
  Large = 'large',
  XLarge = 'xLarge',
}
